import React, { useState, useEffect , useRef } from "react";
import useStyles from "./style";
import { Box, Badge, IconButton, Avatar, Typography, Paper, List, ListItem, ListItemAvatar, ListItemText, TextField, Button, Dialog, Slide, Tooltip, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import { FaCommentDots , FaBell, FaPaperPlane, FaTimes, FaMinusCircle, FaPaperclip, FaSmile } from "react-icons/fa";
import { Portal } from '@mui/material';
import { useSelector } from "react-redux";
import { CUSTOM_CONSTANTS } from '../../../Constants'
import io from "socket.io-client";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import moment from "moment-timezone"
// services 
import PassengerApi from "Services/Passenger";

const StyledChatWindow = styled(Paper)(({ theme }) => ({
  position: "fixed",
  bottom: 20,
  right: 20,
  width: 320,
  height: 400,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  zIndex: 1301
}));

const MessageArea = styled(Box)({
  flex: 1,
  overflowY: "auto",
  padding: "16px"
});

const MessageBubble = styled(Box)(({ sent }) => ({
  backgroundColor: sent ? "#1976d2" : "#dfdfdf",
  color: sent ? "white" : "black",
  borderRadius: "20px",
  padding: "8px 16px",
  margin: "8px 0",
  maxWidth: "70%",
  alignSelf: sent ? "flex-end" : "flex-start"
}));

const NotificationPanel = styled(Paper)({
  position: "absolute",
  top: 60,
  right: 20,
  width: 300,
  maxHeight: 400,
  overflowY: "auto"
});

const ChatApp = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState([]);
  const userId = useSelector(state => state.AuthReducer.userid || "");
  const token = useSelector(state => state.AuthReducer.token || "");
  const [showNotifications, setShowNotifications] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [driverdetails,setdriverdetails]=useState({});
  const [CurrentsenderId,setCurrentsenderId]= useState("");
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

// web socket initialization

const socket = io(CUSTOM_CONSTANTS.API_BASE_URL, {
  query: {
    authtoken: `Bearer ${token}`, // Replace with actual token
  },
 transports: ["websocket"],
 path: "/socket.io/",
 reconnection: true,
 reconnectionAttempts: 5, // Retry on failure
 reconnectionDelay: 2000,  // 2 seconds delay before retry
});

useEffect(() => {
  socket.emit("joinchat", userId);
}, [chatOpen]);

useEffect(() => {

 // console.log('setCurrentsenderId-->',CurrentsenderId);

  socket.on("connect", () => {
   // console.log("Connected to WebSocket Server, ID:", socket.id);
  });

  socket.on("receiveMessage", (data) => {
    const messages = Array.isArray(data) ? data : (data ? [data] : []);
    if(!chatOpen){
     // console.log("Received message for notifications", data);
    setNotifications(
      messages.map((msg) => {
         const driver = msg.driverDetails || {};
    return {
        id: msg._id,
        sender: `${driver.firstName || "Unknown"} ${driver.lastName || ""}`,
        senderId: msg.senderId,
        message: msg.message,
        timestamp: msg.timestamp,
        status:msg.status,
        read: false,
        avatar: driver.image || "",
      }
    }
    )
    );
  }
   setMessages(messages);
  });
  
 return () => {
    socket.off("receiveMessage");
    socket.off("connect");
  };
  
  }, [userId,chatOpen]);

useEffect(() => {
    scrollToBottom();
}, [messages]);



  const handleChatOpen = async (notification) => {
   
    try {
      dispatch(showLoader("Loading please wait..."));
       
      setCurrentsenderId(notification.senderId);

      const passenger = await PassengerApi.getPassengerDetails(notification.senderId);

      await setdriverdetails(passenger?.data?.data);
  
      socket.emit("updatestatus", notification.senderId);

      setShowNotifications(false);

      setNotifications((prevNotifications) =>
        prevNotifications.map((n) =>
          n.id === notification.id ? { ...n, read: true } : n
        )
      );
  
      dispatch(hideLoader());

      setChatOpen(true);
    }
    catch (error) {
      console.error("Error handling passenger details", error);
    }

  };

  const handleSendMessage = async() => {

    if (newMessage.trim()) {
     // console.log('CurrentsenderId-->',newMessage);
    const message = {
        senderId: userId, // Replace with the actual sender ID
        message: newMessage,
        timestamp: moment().format("hh:mm A"),
        status: "sent",
        sent_to: CurrentsenderId,
    };

    setMessages((prev) => [...prev, message]);
    // Emit the message to the backend via socket
    socket.emit("sendMessage", message);

    socket.emit("joinchat", userId);
      setNewMessage("");
    }
  };

  const unreadCount = notifications.filter(n => n.status!=="seen" && n.senderId != userId).length;
    const handleNotificationClick = () => {

if (unreadCount === 0) return;

    setShowNotifications(!showNotifications);
    
    
  };
  const handlechatclose = () => {
    setNewMessage(""); // Clear input
    setChatOpen(false); // Close the chat
  };


  return (
    <Box>
      <Box className={classes.bellnotification}>
        <Tooltip title="Notifications">
        <span> 
          <IconButton onClick={handleNotificationClick}  className={classes.notificationiconbutton} disabled={chatOpen || unreadCount === 0 } >
            <Badge className={classes.notifycount} badgeContent={unreadCount} color="error">
              <FaCommentDots size={24} />
            </Badge>
          </IconButton>
          </span>
        </Tooltip>

        {showNotifications && (
           <Portal>
          <NotificationPanel elevation={3} className={classes.notificationpanel} >
            <List>
              {notifications.map((notification) => (
                notification.status !== "seen" && notification.senderId != userId &&  (
                <ListItem
                  key={notification.id}
                  button
                  onClick={() => handleChatOpen(notification)}
                  sx={{ backgroundColor: notification.read ? "transparent" : "#f0f7ff" }}
                >
                  <ListItemAvatar>
                    <Avatar src={notification.avatar} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={notification.sender}
                    secondary={
                      <Typography variant="body2" noWrap>
                        ! New message
                      </Typography>
                    }
                  />
                </ListItem>
              )
              ))}
            </List>
          </NotificationPanel>
          </Portal>
        )}
      </Box>

      {chatOpen && (
         <Portal>
        <StyledChatWindow elevation={3}>
          <Box sx={{ p: 2, backgroundColor: "#1976d2", color: "white", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={driverdetails.image} />
              <Box>
                <Typography variant="subtitle1">{driverdetails.firstName+" "+driverdetails.lastName}</Typography>
                <Typography variant="caption">Online</Typography>
              </Box>
            </Box>
            <Box>
              <IconButton size="small" onClick={handlechatclose} sx={{ color: "white" }}>
                <FaTimes />
              </IconButton>
            </Box>
          </Box>

          <MessageArea>
           {messages
         .filter(message => 
           message.senderId === CurrentsenderId || message.sent_to === CurrentsenderId
           ).map((message) => (
              <Box
                key={message.id}
                sx={{ display: "flex", flexDirection: "column", alignItems: message.senderId === userId ? "flex-end" : "flex-start" }}
              >
                <MessageBubble name={message.sent_to} sent={message.senderId === userId ? true:false}>
                  <Typography variant="body2">{message.message}</Typography>
                </MessageBubble>
                <Typography variant="caption" sx={{ mt: 0.5 }}>
                  {message.timestamp+" "+(message.senderId === userId? message.status:"")}
                </Typography>
              </Box>
            ))}
           {/* Invisible div for auto-scroll */}
         <div ref={messagesEndRef} />
          </MessageArea>

          <Box sx={{ p: 2, backgroundColor: "#f5f5f5", display: "flex", gap: 1 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Type a message..."
              value={newMessage}
              onChange={(e) => {
                setNewMessage(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
            />
            <IconButton color="primary" onClick={handleSendMessage}  disabled={!newMessage.trim()} >
              <FaPaperPlane />
            </IconButton>
          </Box>
        </StyledChatWindow>
        </Portal>
      )}
    </Box>
  );
};

export default ChatApp;